import { QuestionsValidators, ValidationResultTuple } from '~app/pages/SurveyTaking/validation/types';
import validateQuestion from './validateQuestion';
import { QuestionAnswers } from '../../types';

export default (questionValidators: QuestionsValidators, answers: QuestionAnswers): ValidationResultTuple => {
  // remove the empty validators
  const questionValidatorKeys = Object.keys(questionValidators)?.filter(
    key => questionValidators[key].validators.length
  );

  return questionValidatorKeys.reduce<ValidationResultTuple>(
    (validationState, questionId) => {
      const [pageQuestionsAreValid, errorMessages] = validationState;
      const answer = answers[questionId];
      const answerValue = answer?.value;
      const questionValidation = questionValidators[questionId];

      questionValidation.lastResult = validateQuestion(questionValidation, questionId, answerValue);

      const [questionAnswerIsValid, answerMessages] = questionValidation.lastResult;

      return [questionAnswerIsValid && pageQuestionsAreValid, [...(errorMessages ?? []), ...(answerMessages ?? [])]];
    },
    [true, null]
  );
};
